import { useEffect } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { useWebsocketContext } from '@contexts/websocket';
import { RESUME_SYNC_HIDDEN_THRESHOLD_MS } from './constants';

export const useResumeSync = () => {
  const queryClient = useQueryClient();
  const { ws } = useWebsocketContext();

  useEffect(() => {
    let hiddenAt: number | null = document.hidden ? Date.now() : null;

    const onVisibilityChange = () => {
      if (document.hidden) {
        hiddenAt = Date.now();
        return;
      }
      const wasHiddenLong =
        hiddenAt !== null && Date.now() - hiddenAt > RESUME_SYNC_HIDDEN_THRESHOLD_MS;
      hiddenAt = null;
      if (wasHiddenLong) void queryClient.invalidateQueries();
    };

    document.addEventListener('visibilitychange', onVisibilityChange);
    return () => document.removeEventListener('visibilitychange', onVisibilityChange);
  }, [queryClient]);

  useEffect(() => {
    if (!ws) return;

    return ws.on('connect', ({ reconnect, restored }) => {
      if (reconnect && !restored) void queryClient.invalidateQueries();
    });
  }, [ws, queryClient]);
};
